
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class familyInvitationModal extends Vue {

    @Prop() okCallback: ((email: string) => Promise<any> | void) | null;

    name: string = Date.now().toString();
    email: string = '';
    isSubmitting: boolean = false;

    mounted(){
        const input = this.$refs.emailInput as HTMLInputElement | undefined;
        if(input){
            input.focus();
        }
    }

    submit(){
        if(this.disabled){
            return;
        }

        const trimmedEmail = this.email.trim();
        this.isSubmitting = true;

        const promise = this.okCallback
            ? Promise.resolve(this.okCallback(trimmedEmail))
            : Promise.resolve(this.$emit('submit', trimmedEmail));

        promise
        .catch(() => undefined)
        .finally(() => {
            this.isSubmitting = false;
        });
    }

    closeModal(){
        this.$emit('close');
    }

    get disabled(){
        return !this.emailIsValid || this.isSubmitting;
    }

    get emailIsValid(){
        const value = this.email.trim();
        if(!value) return false;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(value);
    }
}
